import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: uuid(),
    category: "javascript",
    videoId: "C_R6dvU4820",
    title: "Coding with JS 1: Getting Started",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/C_R6dvU4820/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/C_R6dvU4820/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/C_R6dvU4820/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 311,
    views: 164,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "wLtwrYBwD7E",
    title: "Coding with JS 2: Event Listeners",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/wLtwrYBwD7E/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/wLtwrYBwD7E/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/wLtwrYBwD7E/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 464,
    views: 315,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "QyJW1yJvwqg",
    title: "Coding with JS 3: Reading from input in html",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/QyJW1yJvwqg/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/QyJW1yJvwqg/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/QyJW1yJvwqg/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 64,
    views: 393,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "2vtYq6wjBXo",
    title: "Coding with JS 4: Writing to DOM",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/2vtYq6wjBXo/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/2vtYq6wjBXo/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/2vtYq6wjBXo/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 229,
    views: 87,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "SLwdkFczQNA",
    title: "Coding with JS 5: Arrays & Objects",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/SLwdkFczQNA/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/SLwdkFczQNA/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/SLwdkFczQNA/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 180,
    views: 858,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "vSQnpxfS9W8",
    title: "Coding with JS 6: Processing Data on User Action",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/vSQnpxfS9W8/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/vSQnpxfS9W8/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/vSQnpxfS9W8/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 483,
    views: 414,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "amTn4KB4RL8",
    title: "Coding with JS 7:  Templating in JavaScript",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/amTn4KB4RL8/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/amTn4KB4RL8/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/amTn4KB4RL8/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 467,
    views: 7,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "G7FUyJ__iI4",
    title: "Coding with JS 8: generating HTML from JavaScript",
    description:
      "Learn programming by doing and making things. This way you will learn things you use and there's no textbook needed to get started. Make an app in pure Javascript with this course.\nvanillaJS is Javascript without frameworks or libraries. More and more developers depends on abstractions provided by JQuery, React, Angular etc. This makes them dependent and binds them into that ecosystem. This also sometimes increase the bundle size for small apps.\nThis course aims to free you from these dependencies.\n\nI am doing this all in my time after office, if you like it please show some love by liking the videos, posting some comments. This fuels my motivation to be honest! \nAnd.. Don't forget to subscribe the channel!!\n\nFollow tanaypratap on Instagram:\nhttps://www.instagram.com/tanaypratap/\n\nOr, if you're a twitter person:\nhttps://twitter.com/tanaypratap\n\nShare your progress or ask your doubts on the FB community:\nhttp://bit.ly/metastartup-fb\n\n\nMozilla Docs ::  Should be your goto place for anything Javascript\nhttps://developer.mozilla.org/en-US/",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/G7FUyJ__iI4/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/G7FUyJ__iI4/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/G7FUyJ__iI4/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 874,
    views: 524,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "274lJxMHgAs",
    title: "vanillaJS IX: Using Bootstrap to style the app",
    description:
      "Bootstrap is one of the most used CSS framework. The app is almost ready but the design needs some work. In this lesson we explore the Bootstrap website and some of the things it provides.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/274lJxMHgAs/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/274lJxMHgAs/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/274lJxMHgAs/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 349,
    views: 652,
  },
  {
    _id: uuid(),
    category: "javascript",
    videoId: "VG9fkzzhqOs",
    title: "vanillaJS X: Understanding Bootstrap and Design Walkthrough",
    description:
      "The new look is powered by Bootstrap and this does look good. What are the components which we are using? How are they placed? What do the tags mean? This lesson delves deeper into Bootstrap 4 and how we are going to use it.\n\nBelow is the gist as promised. Thanks for the reminder comment :)\nhttps://gist.github.com/tanaypratap/441a46b738459a713d154e7c1d0cc861",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/VG9fkzzhqOs/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/VG9fkzzhqOs/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/VG9fkzzhqOs/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 258,
    views: 387,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "MRVHxQ2SiOM",
    title: "Cannot find module in node.js",
    description:
      "What's issue Cannot find module Just Type command in terminal or command prompt npm install package-name Thank's for ...",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/MRVHxQ2SiOM/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/MRVHxQ2SiOM/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/MRVHxQ2SiOM/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 860,
    views: 3,
  },

  {
    _id: uuid(),
    category: "node",
    videoId: "X1_HA0Ts_0o",
    title: "My javascript code is not working ?",
    description:
      "error that come when run javascript code : My javascript code is not working solution.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/X1_HA0Ts_0o/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/X1_HA0Ts_0o/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/X1_HA0Ts_0o/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 619,
    views: 605,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "7UT2hINdsGU",
    title: "Refused to execute inline event handler in chrome extension",
    description:
      "problem : chrome extension Refused to execute inline event handler because it violates the following Content Security Policy ...",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/7UT2hINdsGU/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/7UT2hINdsGU/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/7UT2hINdsGU/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 840,
    views: 301,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "8uCS4BqbQQ4",
    title: "src refspec master does not match any.",
    description: "python error that is src refspec master does not match any.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/8uCS4BqbQQ4/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/8uCS4BqbQQ4/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/8uCS4BqbQQ4/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 898,
    views: 980,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "9foBf9QHSws",
    title: "No Module Named bs4 (BeautifulSoup)",
    description:
      "this python error will be generated when we are not installing BeautifulSoup4 module. for this run this command.... pip install ...",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/9foBf9QHSws/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/9foBf9QHSws/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/9foBf9QHSws/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 48,
    views: 284,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "2GpfmrdDOFQ",
    title: "No module named request",
    description: "Error : Explain this Django error.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/2GpfmrdDOFQ/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/2GpfmrdDOFQ/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/2GpfmrdDOFQ/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 436,
    views: 290,
  },
  {
    _id: "5e4762b4-f20f-459d-90cd-e8d16ed9ec4c",
    category: "python",
    videoId: "TFfrrEBhorQ",
    title: "table &quot;django_content_type&quot; already exists",
    description:
      'django error : table "django_content_type" already exists command : python manage.py migrate --fake-initial.',
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/TFfrrEBhorQ/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/TFfrrEBhorQ/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/TFfrrEBhorQ/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 817,
    views: 884,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "Kpt-_xhCkEA",
    title: "A server error occurred.  Please contact the administrator.",
    description:
      "django problem solving that are django-improperlyconfigured-module-django-contrib-auth-middleware or A server error occurred.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/Kpt-_xhCkEA/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/Kpt-_xhCkEA/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/Kpt-_xhCkEA/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 605,
    views: 212,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "awF-WnIALZc",
    title: "SOUTH_DATABASE_ADAPTERS for my Django app that uses South",
    description:
      "How should I be setting SOUTH_DATABASE_ADAPTERS for my Django app that uses South?",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/awF-WnIALZc/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/awF-WnIALZc/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/awF-WnIALZc/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 196,
    views: 766,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "e5kmRkYYXdM",
    title: "databases is improperly configured",
    description: "solution of settings.databases is improperly configured.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/e5kmRkYYXdM/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/e5kmRkYYXdM/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/e5kmRkYYXdM/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 414,
    views: 507,
  },
  {
    _id: uuid(),
    category: "python",
    videoId: "i2GbK0o0ZDQ",
    title: "relation django site does not exist",
    description: "solution of relation django site does not exist .",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/i2GbK0o0ZDQ/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/i2GbK0o0ZDQ/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/i2GbK0o0ZDQ/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "rahul shukla",
    isWatchlist: false,
    isLiked: false,
    isDisliked: false,
    likes: 117,
    views: 72,
  },

  {
    _id: uuid(),
    category: "react",
    videoId: "dN15USae2ik",
    title: "ReactJS for Absolute Beginners",
    description:
      "If you're new to ReactJS, this is the live session for you. We'll have workshop, quizzes and exercises together and before you know you would have learned React!\n\nSlides are here: https://slides.com/tanaypratap/reactjs-live#/\n\nFollow on Instagram for daily quizzes: https://instagram.com/tanaypratap\n\nThe community of coders who are doing these courses is here:\nhttps://www.facebook.com/groups/328710937827045\n\nHere is the live doc we used with all the links:\nhttp://bit.ly/tanay-react-workshop-1-notes",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/dN15USae2ik/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/dN15USae2ik/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/dN15USae2ik/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 856,
    views: 377,
  },
  {
    _id: uuid(),
    category: "react",
    videoId: "9pRhkECs1rM",
    title: "Revision Session for ReactJS Beginners",
    description:
      "This is just a revision session\n\nHere are the live notes: https://codepen.io/tanaypratap/pen/NWKOjQz?editors=0010",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/9pRhkECs1rM/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/9pRhkECs1rM/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/9pRhkECs1rM/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 318,
    views: 173,
  },
  {
    _id: uuid(),
    category: "react",
    videoId: "BqPoQCCJ_Ds",
    title: "Props and Components for ReactJS Beginners",
    description:
      "Live notes here\nhttps://codepen.io/tanaypratap/post/forms-and-props-react-3\n\nProps are extremely useful in React. Data passes from parent to child using props. Props are required even more as you don't want to put logic in all components. So, you pass logic via event handlers using props too! \nIt makes the code look better and easier to understand. It also introduces molecularity in code. If you want to redesign/refactor tomorrow it's much easier to work on individual components.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/BqPoQCCJ_Ds/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/BqPoQCCJ_Ds/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/BqPoQCCJ_Ds/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Tanay Pratap",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 219,
    views: 741,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "mIW_8dMQaUk",
    title:
      "Node.JS #2: Install Node JS, NPM, VS Code IDE & Running our First Node.JS Script",
    description:
      "Welcome, we will see how to install node js in our local system, also vs code editor, and runs our first node.js script.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/mIW_8dMQaUk/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/mIW_8dMQaUk/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/mIW_8dMQaUk/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 265,
    views: 203,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "aW9Zv2q7T1s",
    title:
      "🔴 NodeJS #3: Prerequisites For Node.JS | What you should Learn Before Node.JS",
    description:
      "Welcome, Prerequisites to Learn Node.JS | What you should Learn Before Node.JS.\nBefore start learning any new languages (In our case NodeJS), it is always better to first learn all the important topics or languages from which the NodeJS actually come into existence.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/aW9Zv2q7T1s/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/aW9Zv2q7T1s/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/aW9Zv2q7T1s/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 473,
    views: 375,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "uJOsl4x7pAo",
    title:
      "Node.JS #4: 📑 Complete REPL in NodeJS | READ, Eval, Print & Loop in NodeJS",
    description:
      "Welcome, what is REPL in Node.JS in Hindi in 2020. So, REPL stands for Read Eval Print Loop and it represents a computer environment like a Windows console or Unix/Linux shell where a command is entered and the system responds with output in an interactive mode.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/uJOsl4x7pAo/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/uJOsl4x7pAo/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/uJOsl4x7pAo/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 922,
    views: 147,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "5uZDLL0zaWg",
    title:
      "🔴 #5: Mastering the Node.js Core Modules | File System Node.js Module",
    description:
      "Welcome, on how to master the node.js core modules in Hindi. There are many core modules in Node.js. We will see Node.js File System Modules.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/5uZDLL0zaWg/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/5uZDLL0zaWg/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/5uZDLL0zaWg/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 458,
    views: 161,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "0F-nudTm5EU",
    title: "🔴 Node.JS Challenge #1: CRUD Operations using FS Module in NodeJS",
    description:
      "Welcome, to the First NodeJS Challenge video on CRUD Operations using FS Module in NodeJS.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/0F-nudTm5EU/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/0F-nudTm5EU/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/0F-nudTm5EU/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 33,
    views: 581,
  },
  {
    _id: uuid(),
    category: "node",
    videoId: "CgEZYq7A9xU",
    title:
      "#7: Node.JS Asynchronous File System Core Modules | Reading and Writing File Asynchronously.",
    description:
      "Welcome, What is Node.JS Asynchronous File System Core Modules | Reading and Writing File Asynchronously.",
    thumnailMedium: {
      url: "https://i.ytimg.com/vi/CgEZYq7A9xU/mqdefault.jpg",
      width: 320,
      height: 180,
    },
    thumnailDefault: {
      url: "https://i.ytimg.com/vi/CgEZYq7A9xU/default.jpg",
      width: 120,
      height: 90,
    },
    thumnailHigh: {
      url: "https://i.ytimg.com/vi/CgEZYq7A9xU/hqdefault.jpg",
      width: 480,
      height: 360,
    },
    author: "Thapa Technical",
    isWatechList: false,
    isLiked: false,
    isDisliked: false,
    likes: 333,
    views: 865,
  },
];
